import React from 'react';
import { Check, X, ArrowRight, Clock, Target, Shield, BarChart3, Users, Layers } from 'lucide-react';
import { motion } from 'framer-motion';
export function AdvantageProduct() {
  return <div className="min-h-screen w-full bg-[#0B1120] text-slate-200 selection:bg-emerald-500/30 font-sans" data-id="element-253">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-254">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-emerald-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-255" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-256">
          <div className="inline-block px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-257">
            Flagship Partnership
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-258">
            HIRE Advantage
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-259">
            Recruiting stops being a scramble when someone owns the system — not
            just the traffic.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-260">
            HIRE Advantage is the partnership where recruiting becomes
            consistent, predictable, and scalable.
          </p>
        </motion.div>
      </section>

      {/* 2. PROBLEM REFRAME */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-261">
        <div className="text-center mb-12" data-id="element-262">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-263">
            The Real Problem
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-264">
            Most companies don't fail at finding candidates. They fail at system
            execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-265">
          <div className="bg-slate-900/30 border border-slate-800 p-8 rounded-xl" data-id="element-266">
            <h3 className="text-sm text-rose-400 uppercase tracking-widest font-bold mb-6" data-id="element-267">
              System Failures
            </h3>
            <ul className="space-y-4" data-id="element-268">
              {['Inconsistent interviews', 'Drifting hiring standards', 'Early churn discovered too late', 'Leaders relying on gut decisions'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-269">
                  <X className="w-5 h-5 text-rose-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-270" />
                  <span className="line-through opacity-70" data-id="element-271">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center p-8" data-id="element-272">
            <p className="text-xl text-white font-medium mb-4" data-id="element-273">
              Advantage solves the system failure, not just the talent shortage.
            </p>
            <p className="text-slate-400" data-id="element-274">
              We replace guesswork with infrastructure and accountability.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT ADVANTAGE IS */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-275">
        <div className="max-w-5xl mx-auto" data-id="element-276">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-277">
            <div data-id="element-278">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-279">
                Full System Ownership
              </h2>
              <div className="space-y-4 text-slate-400 mb-8" data-id="element-280">
                <p data-id="element-281">This is not lead generation.</p>
                <p data-id="element-282">This is not outsourced recruiting.</p>
                <p data-id="element-283">This is full ownership of the recruiting system.</p>
              </div>
              <div className="p-6 bg-emerald-500/5 border border-emerald-500/20 rounded-lg" data-id="element-284">
                <p className="text-emerald-400 font-medium" data-id="element-285">
                  HIRE Advantage is the only partnership level where HIRE is
                  accountable for the recruiting system actually working.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-286">
              <div className="flex items-start" data-id="element-287">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-288">
                  <Shield className="w-6 h-6 text-emerald-400" data-id="element-289" />
                </div>
                <div data-id="element-290">
                  <h3 className="text-white font-bold mb-2" data-id="element-291">Accountability</h3>
                  <p className="text-slate-400 text-sm" data-id="element-292">
                    We don't just deliver leads; we own the outcome of the
                    system's performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-293">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-294">
                  <Target className="w-6 h-6 text-emerald-400" data-id="element-295" />
                </div>
                <div data-id="element-296">
                  <h3 className="text-white font-bold mb-2" data-id="element-297">Consistency</h3>
                  <p className="text-slate-400 text-sm" data-id="element-298">
                    Eliminating the variance between good weeks and bad weeks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 10-STEP SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-299">
        <div className="text-center mb-12" data-id="element-300">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-301">
            The 10-Step Recruiting System
          </h2>
          <p className="text-slate-400" data-id="element-302">
            Every HIRE Advantage partner runs the same system. The difference is
            who owns it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-303">
          {['Attract', 'Engage', 'Screen', 'Qualify', 'Commit', 'Schedule', 'Launch', 'Integrate', 'Train', 'Retain'].map((step, idx) => <div key={idx} className="bg-slate-900/40 border border-slate-800 p-6 rounded-lg text-center hover:border-emerald-500/30 transition-colors group" data-id="element-304">
              <div className="text-xs text-slate-500 mb-2 font-mono" data-id="element-305">
                0{idx + 1}
              </div>
              <div className="text-white font-medium group-hover:text-emerald-400 transition-colors" data-id="element-306">
                {step}
              </div>
            </div>)}
        </div>
      </section>

      {/* 5. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-307">
        <div className="max-w-6xl mx-auto" data-id="element-308">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-309">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-310">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-emerald-500/20 rounded-xl p-8 relative overflow-hidden" data-id="element-311">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500" data-id="element-312" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-313">
                <span className="w-2 h-2 rounded-full bg-emerald-500 mr-3" data-id="element-314" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-315">
                {['Recruiting system architecture (custom ATS)', 'Traffic, screening, and qualification standards', 'Hiring consistency and interview structure', 'Sales School and launch readiness', 'Early performance tracking and correction', 'Ongoing optimization and accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-316">
                    <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-317" />
                    <span data-id="element-318">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-319">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-320" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-321">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-322" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-323">
                {['Final hiring decisions', 'Day-to-day sales leadership', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-324">
                    <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-325">
                      <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-326" />
                    </div>
                    <span data-id="element-327">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. FIRST 90 DAYS */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-328">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-329">
          First 90 Days
        </h2>

        <div className="relative" data-id="element-330">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-slate-800 -translate-x-1/2 hidden md:block" data-id="element-331" />

          <div className="space-y-12" data-id="element-332">
            {[{
            days: 'Days 1–30',
            title: 'Setup & Alignment',
            items: ['System setup and alignment', 'Hiring standards locked', 'Sales School completed', 'First cohorts launched with visibility']
          }, {
            days: 'Days 31–60',
            title: 'Tracking & Correction',
            items: ['Early performance tracked', 'Issues corrected before churn', 'Hiring decisions improve with data']
          }, {
            days: 'Days 61–90',
            title: 'Predictability',
            items: ['Predictable output', 'Recruiting becomes repeatable', 'Clear upgrade paths']
          }].map((phase, idx) => <div key={idx} className={`flex flex-col md:flex-row items-center ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-333">
                <div className="w-full md:w-1/2 p-4 md:p-8" data-id="element-334">
                  <div className={`bg-slate-900/30 border border-slate-800 p-6 rounded-xl ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-335">
                    <div className="text-emerald-400 font-bold text-sm uppercase tracking-widest mb-2" data-id="element-336">
                      {phase.days}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-4" data-id="element-337">
                      {phase.title}
                    </h3>
                    <ul className={`space-y-2 ${idx % 2 === 0 ? '' : 'md:flex md:flex-col md:items-end'}`} data-id="element-338">
                      {phase.items.map((item, i) => <li key={i} className="text-slate-400 text-sm flex items-center" data-id="element-339">
                          {idx % 2 !== 0 && <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-slate-700 ml-2 order-2" data-id="element-340" />}
                          <span className={idx % 2 !== 0 ? 'md:mr-0' : ''} data-id="element-341">
                            {item}
                          </span>
                          {(idx % 2 === 0 || window.innerWidth < 768) && <span className="w-1.5 h-1.5 rounded-full bg-slate-700 ml-2 md:ml-0 md:mr-2 md:order-first" data-id="element-342" />}
                        </li>)}
                    </ul>
                  </div>
                </div>
                <div className="w-8 h-8 rounded-full bg-slate-900 border-4 border-slate-800 z-10 hidden md:block" data-id="element-343" />
                <div className="w-full md:w-1/2" data-id="element-344" />
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. PRICING */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-345">
        <div className="max-w-6xl mx-auto" data-id="element-346">
          <div className="text-center mb-12" data-id="element-347">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-348">
              Partnership Pricing
            </h2>
            <p className="text-slate-400" data-id="element-349">
              Recruiting stops being a scramble when someone owns the system —
              not just the traffic.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-350">
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-351">
              <div className="mb-4" data-id="element-352">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-353">
                  Build (One-Time)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-354">$5,000</div>
              </div>
            </div>

            <div className="bg-slate-900/40 border border-emerald-500/30 p-6 rounded-xl relative" data-id="element-355">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500 rounded-t-xl" data-id="element-356" />
              <div className="mb-4" data-id="element-357">
                <div className="text-xs text-emerald-500 uppercase tracking-widest mb-2" data-id="element-358">
                  System (Monthly)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-359">$2,500</div>
                <div className="text-xs text-slate-500 mt-1" data-id="element-360">/ month</div>
              </div>
            </div>

            <div className="bg-slate-900/40 border border-emerald-500/30 p-6 rounded-xl relative" data-id="element-361">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500 rounded-t-xl" data-id="element-362" />
              <div className="mb-4" data-id="element-363">
                <div className="text-xs text-emerald-500 uppercase tracking-widest mb-2" data-id="element-364">
                  Campaign (Monthly)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-365">$2,500</div>
                <div className="text-xs text-slate-500 mt-1" data-id="element-366">
                  / month per campaign
                </div>
              </div>
            </div>

            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-367">
              <div className="mb-4" data-id="element-368">
                <div className="text-xs text-amber-400 uppercase tracking-widest mb-2" data-id="element-369">
                  Performance Bonuses
                </div>
                <ul className="space-y-2 text-sm text-slate-300" data-id="element-370">
                  <li className="flex items-start" data-id="element-371">
                    <span className="text-amber-400 mr-2" data-id="element-372">$250</span>
                    <span className="text-slate-400" data-id="element-373">per rep at launch</span>
                  </li>
                  <li className="flex items-start" data-id="element-374">
                    <span className="text-amber-400 mr-2" data-id="element-375">$250</span>
                    <span className="text-slate-400" data-id="element-376">per rep at 30 days</span>
                  </li>
                  <li className="flex items-start" data-id="element-377">
                    <span className="text-amber-400 mr-2" data-id="element-378">$250</span>
                    <span className="text-slate-400" data-id="element-379">per rep at 60 days</span>
                  </li>
                  <li className="flex items-start" data-id="element-380">
                    <span className="text-amber-400 mr-2" data-id="element-381">$250</span>
                    <span className="text-slate-400" data-id="element-382">per rep at 90 days</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-emerald-500/5 border border-emerald-500/20 rounded-lg max-w-3xl mx-auto" data-id="element-383">
            <p className="text-emerald-400 text-center font-medium" data-id="element-384">
              Bonuses are only paid when reps reach real performance milestones.
            </p>
          </div>
        </div>
      </section>

      {/* 8. WHO THIS IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-385">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-386">
          <div data-id="element-387">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-388">
              <Check className="w-5 h-5 text-emerald-500 mr-2" data-id="element-389" />
              This is for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-390">
              {['Want recruiting to actually work', 'Value consistency over heroics', 'Are open to better systems', 'Want a partner, not a vendor'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-391">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-3 mt-2" data-id="element-392" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-393">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-394">
              <X className="w-5 h-5 text-rose-500 mr-2" data-id="element-395" />
              This is not for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-396">
              {['Only want resumes', "Aren't open to process", 'Want zero accountability'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-397">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-3 mt-2" data-id="element-398" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 9. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-399">
        <div className="max-w-3xl mx-auto" data-id="element-400">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-401">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-402">
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-403">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-404">
                Infrastructure
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-405">Edge</h3>
              <p className="text-slate-400 text-sm" data-id="element-406">
                Exists for infrastructure-only needs.
              </p>
            </div>
            <div className="flex-1 p-6 border border-emerald-500/30 rounded-lg bg-slate-800/30" data-id="element-407">
              <div className="text-xs text-emerald-500 uppercase tracking-widest mb-2" data-id="element-408">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-409">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-410">
                The foundation that makes both work.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-411">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-412">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-413">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-414">
                Exists when execution capacity is the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. CTA */}
      <section className="py-32 px-6 md:px-12 text-center" data-id="element-415">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-416">
          Ready to make recruiting predictable?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-417">
          Let's see if Advantage is the right fit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-418" />
        </button>
      </section>
    </div>;
}